const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container footer-grid">

        {/* About */}
        <div className="footer-col">
          <h3>Popular Watch and Opticals</h3>
          <p>
            Your trusted partner for eye care and premium watches in Masrakh.
            Quality products, expert service, affordable prices.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About Us</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#products">Products</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        {/* Services */}
        <div className="footer-col">
          <h4>Our Services</h4>
          <ul>
            <li>Eye Check-up</li>
            <li>Spectacle Fitting</li>
            <li>Designer Frames</li>
            <li>Premium Watches</li>
            <li>Watch Repairs</li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-col">
          <h4>Contact Info</h4>
          <p>
            📍 Station Road Main Market, Masrakh, Bihar <br />
            📞 <a href="tel:9905061329<br>9546525492">+91-9905061329,9546525492</a> <br />
            ✉️ <a href="mailto:info@popularwatchopticals.com">
              info@popularwatchopticals.com
            </a>
          </p>

          <p className="timings">
            <strong>Timings:</strong><br />
            Mon–Sat: 8:00 AM – 8:00 PM <br />
            Sun: 8:00 AM – 8:00 PM
          </p>
        </div>

      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p>
          © 2026 Popular Watch and Opticals. All rights reserved.
        </p>
        <div className="footer-links">
          <a href="#privacy">Privacy Policy</a>
          <span>|</span>
          <a href="#terms">Terms of Service</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
